<template>
  <div>
    <home-page-blockbuster-module
      id="home-page-blockbuster"
      :items="data.blockbuster.items"
    />
  </div>
</template>

<script setup lang="ts">
import type { StrapiHomePage } from '~/apollo/types/types';

defineProps<{
  data: StrapiHomePage;
}>();
</script>
